import React from 'react'
import styled from 'styled-components'
import { Container } from '@rst/ui-ts'
import { BlockPreload } from '@rst/render-blocks'

const Preloader = () => {
	return (
		<Container>
			<Wrapper>
				{Array.from({ length: 4 }).map((_, i) => (
					<BlockPreload key={i} />
				))}
			</Wrapper>
		</Container>
	)
}

export { Preloader }

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	width: 100%;
	gap: 24px;
`
